export default __webpack_public_path__ + "assets/models/157769df3783cc627169af6548261e5c.glb";